import React, { useEffect } from "react";
import { connect } from "react-redux";
import { setCurrentClient } from "thunks";
import { uniqBy } from "lodash";
import { updateUrlFilter } from "../services/utils";
import { setStatisticsEventsFilter } from "../actions/actions/statistics";
import NotFoundFrame from "../pages/NotFoundFrame";

const CommunityRedirect = ({ routeParams, auth, dispatch }) => {

  useEffect(() => {
    if (auth.user && routeParams.communityId !== undefined) {
      let paymentClients = uniqBy(auth.user.paymentClients, "id");
      const community = paymentClients.find(
        client => client.id == routeParams.communityId
      );

      dispatch(setStatisticsEventsFilter([]));
      window.history.replaceState(null, null, document.referrer);

      dispatch(setCurrentClient(community)).then(() => {
        updateUrlFilter("appRefs", "in", []);
        updateUrlFilter("clientId", "in", [routeParams.communityId]);
      });
    }
  }, []);

  // return <NotFoundFrame />;
  return null;
};

const mapStateToProps = (store) => ({
  auth: store.auth,
});

export default connect(mapStateToProps)(CommunityRedirect);


// WEBPACK FOOTER //
// ./app/components/CommunityRedirect.js